import { HandHeart, Ruler, ShieldCheck } from "lucide-react";

const POINTS = [
  { icon: HandHeart, title: "Personal help", text: "Tell us what you're fixing or cooking — we'll suggest the right piece, not the costliest one." },
  { icon: Ruler, title: "The right size, first time", text: "Bring a photo or measurement on WhatsApp and we'll match fittings, lids and sizes for you." },
  { icon: ShieldCheck, title: "Honest, local shop", text: "A neighbourhood store in the lanes of Mamura, here for the families of Sector 66." },
];

export const StoreStory = () => (
  <section id="story" className="relative overflow-hidden bg-[#1B4332] text-[#FDFBF7] scroll-mt-20" data-testid="store-story-section">
    <div className="grain absolute inset-0" />
    <div className="relative mx-auto grid max-w-7xl gap-12 px-4 py-20 sm:px-6 md:grid-cols-12 md:py-28 lg:px-8">
      <div className="md:col-span-5">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#C59B27]">Our story</p>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold leading-tight">From our gali to your ghar.</h2>
        <p className="mt-6 text-base leading-relaxed text-[#E8E2D4]">
          RamVilas is a family-run neighbourhood store in Village Mamura. From everyday kitchen utensils to the small hardware bits that keep a home running, we keep things simple: useful products, fair advice and a warm welcome every time you walk in.
        </p>
        <p className="mt-4 font-deva text-xl text-[#F3DB8C]">आपकी अपनी दुकान</p>
      </div>
      <ul className="md:col-span-7 grid gap-4 sm:grid-cols-1">
        {POINTS.map(({ icon: Icon, title, text }) => (
          <li key={title} className="flex gap-5 rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm transition-colors duration-300 hover:bg-white/10">
            <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-[#C59B27]/20 text-[#F3DB8C]"><Icon className="h-6 w-6" /></span>
            <div>
              <h3 className="font-display text-xl font-semibold">{title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-[#D9D3C4]">{text}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
